const Backbone = require('backbone');
const Template = require('view');
const tpl = $('script[name=tpl-view-desconto]').html();

const Cupom = require('../models/cupom');

const View = Backbone.View.extend({
	tagName: 'form',
	initialize: function() {
		var that = this;
		
		that.listenTo(Cupom, 'change', that.render);

		that.render();
	},
	events: {
		'submit': 'setCupom'
	},
	setCupom: function(e) {
		var that = this;
		try {			
			if (that.enviando) {
				return false;
			}			
			if (Cupom.get('codigo') == '') {
				that.addCupom();
			} else {
				that.removerCupom();
			}
		} catch (e) {
			console.log(e);
		}


		return false;
	},
	addCupom: function() {
		var that = this;



		var codigo = that.$el.find('[name=codigo]').val();
		if ('' == codigo) {
			alert("Informe o código do cupom.");
			return false;
		}

		that.enviando = true;
		jQuery.fancybox.showLoading();

		var callback = function(resp) {
			if (undefined != resp.redirect_url) {
				location.href = resp.redirect_url;
				return;
			}

			jQuery.fancybox.hideLoading();
			that.enviando = false;

			if (undefined != resp.popup_url) {
				jQuery.fancybox.open([{
					href: resp.popup_url,
					type: 'ajax'
				}],{});
				return;
			}

			if (resp.success) {
				Cupom.set({
					codigo: codigo,
					desconto: resp.desconto
				});
			} else {
				alert(resp.msg);
			}
		};

		$.ajax({
			url: 'carrinho/set-cupom',
			type: 'post',
			dataType: 'json',
			data: {
				codigo: codigo
			},
			success: callback,
			error: function() {
				callback({
					success: false,
					msg: "Não foi possível adicionar o cupom ao carrinho atual."
				});
			}
		});


	},
	removerCupom: function() {
		var that = this;

		that.enviando = true;
		jQuery.fancybox.showLoading();

		var callback = function(resp) {
			if (undefined != resp.redirect_url) {
				location.href = resp.redirect_url;
				return;
			}

			jQuery.fancybox.hideLoading();
			that.enviando = false;

			if (undefined != resp.popup_url) {
				jQuery.fancybox.open([{
					href: resp.popup_url,
					type: 'ajax'
				}],{});
				return;
			}

			if (resp.success) {
				Cupom.set({
					codigo: '',
					desconto: 0.0
				});
			} else {
				alert(resp.msg);
			}
		};

		$.ajax({
			url: 'carrinho/remove-cupom',
			type: 'post',
			dataType: 'json',
			success: callback,
			error: function() {
				callback({
					success: false,
					msg: "Não foi possível remover o cupom do carrinho atual."
				});
			}
		});

	},
	render: function() {
		var that = this;

		var data = Cupom.toJSON();

		that.$el.html(Template.renderString(tpl,data));
	}
});

module.exports = View;


//////////////////
// WEBPACK FOOTER
// ../src/carrinho/views/desconto.js
// module id = 67
// module chunks = 0